import { t } from "@travily/i18n";
import { Alert, type AlertStatus } from "@ui/components/Alert";
import { SkeletonBox } from "@ui/components/Skeleton";
export type PayoutsStatus = "unstarted" | "pending" | "restricted" | "completed";

export interface PayoutsBannerProps {
  status: PayoutsStatus;
  /** Unstarted: opens the country picker so the seller can begin onboarding. */
  onSetUpPayouts: () => void;
  /** Pending or restricted: regenerates a fresh Stripe onboarding link before redirecting. */
  onResumePayouts: () => void;
}

// i18n-tasks-use t('components.views.creator.payouts_banner.unstarted.title')
// i18n-tasks-use t('components.views.creator.payouts_banner.unstarted.description')
// i18n-tasks-use t('components.views.creator.payouts_banner.unstarted.action')
// i18n-tasks-use t('components.views.creator.payouts_banner.pending.title')
// i18n-tasks-use t('components.views.creator.payouts_banner.pending.description')
// i18n-tasks-use t('components.views.creator.payouts_banner.pending.action')
// i18n-tasks-use t('components.views.creator.payouts_banner.restricted.title')
// i18n-tasks-use t('components.views.creator.payouts_banner.restricted.description')
// i18n-tasks-use t('components.views.creator.payouts_banner.restricted.action')

const ALERT_STATUS: Record<Exclude<PayoutsStatus, "completed">, AlertStatus> = {
  unstarted: "info",
  pending: "info",
  restricted: "warning",
};

export function PayoutsBanner({ status, onSetUpPayouts, onResumePayouts }: PayoutsBannerProps) {
  if (status === "completed") return null;

  const title = t(`components.views.creator.payouts_banner.${status}.title`);
  const description = t(`components.views.creator.payouts_banner.${status}.description`);
  const onPress = status === "unstarted" ? onSetUpPayouts : onResumePayouts;

  return (
    <Alert status={ALERT_STATUS[status]} title={title} description={description}>
      <Alert.Action label={t(`components.views.creator.payouts_banner.${status}.action`)} onPress={onPress} />
    </Alert>
  );
}

export function PayoutsBannerSkeleton() {
  return <SkeletonBox className="h-20 w-full" rounded="lg" />;
}
